import { render, staticRenderFns } from "./CumulativeList.vue?vue&type=template&id=15f4b623&scoped=true"
import script from "./CumulativeList.vue?vue&type=script&lang=js"
export * from "./CumulativeList.vue?vue&type=script&lang=js"
import style0 from "./CumulativeList.vue?vue&type=style&index=0&id=15f4b623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f4b623",
  null
  
)

export default component.exports